<template>
  <div class="navbar layout-1 relative">
    <img
      src="@/assets/images/home_store_support.svg"
      class="logo-img cursor-pointer"
      @click="toHomePage"
      style="padding: 12px;"
    />
    
    <div v-if="this.$store.state.isAuthenticate">
      <button class="btn btn-light d-flex align-items-center rounded-pill shadow-lg px-4 py-2" @click="toCreateIssue">
        <img src="@/assets/images/icon-awesome-plus-circle.svg" class="mr-2" alt="search" width="20" height="20" />
        <span class="fw-semibold text-danger">Ticket/แจ้งปัญหา</span>
      </button>
    </div> 
  </div>
  <ModalLoading ref="modalLoading" />
</template>

<script>
import ModalLoading from "@/components/other/ModalLoading.vue";
export default {
  components: {
    ModalLoading
  },
  data() {
    return {
    };
  },
  methods: {
    toHomePage() {
      this.$router.push("/issue");
    },
    toCreateIssue() {
      this.$router.push("/issue/create");
    },
  }
};
</script>

<style lang="scss" scoped>

.navbar {
  overflow: hidden;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 5;
  background-color: var(--theme-navigation-bar-color);
  transition: background-color 0.1s linear;
  box-shadow: 1px 1px 5px -3px black;
}

.new-theme {
  .layout-1 {
    min-height: 60px;
    background-color: #e31e26;
    padding: 0 0.5rem 0 0.25rem;
    .logo-img {
      width: auto;
      max-width: 200px;
      height: 100%;
      max-height: 60px;
    }

    .custom-circle {
      background-color: #e31e26;
      color: white;
    }
  }
}
</style>
